import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  disable(event) {
    if (event.submitter) {
      event.submitter.disabled = true;
    }
  }
}
